import { inject, Injectable } from '@angular/core';
import { CmsApiService } from './api/cms-api.service';
import { map } from 'rxjs/operators';
import { CmsContentMapperService } from './cms-content-mapper.service';
import { ContentUpdaterService } from './content-updater/content-updater.service';

@Injectable({
  providedIn: 'root'
})
export class StaticContentService {
  private _api = inject(CmsApiService);
  private _mapper = inject(CmsContentMapperService);
  private _contentUpdater = inject(ContentUpdaterService);


  /**
   * Get static content item from CMS and prepare for using in frontend
   *
   * @param params
   */
  item(params: object = {}) {
    return this._contentUpdater.registerContent('static-content/item', params, () =>
      this._api.staticContentItem(params).pipe(
        map(response => this._mapper.mapCmsData(response.data && response.data.item)),
      ),
    );
  }

  /**
   * Get static content list from CMS and prepare for using in frontend
   *
   * @param params
   */
  list(params: object = {}) {
    return this._contentUpdater.registerContent('static-content/list', params, () =>
      this._api.staticContentList(params).pipe(
        map(response => this._mapper.mapCmsData(response.data && response.data.list)),
      ),
    );
  }

}
